import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { DropdownItem } from '../ipopover-content/ipopovercontent.component';
import { DropdownMenuItem, IDropdownComponent } from '../i-dropdown/i-dropdown.component';
import { IButtonComponent } from '../ibutton/ibutton.component';

export interface GridDropdownParams {
  label: string;
  icon: string;
  items: DropdownMenuItem[][];
}

@Component({
  selector: 'lib-grid-dropdown',
  standalone: true,
  imports: [CommonModule, IDropdownComponent, IButtonComponent],
  templateUrl: './grid-dropdown.component.html',
})
export class GridDropdownComponent implements ICellRendererAngularComp {
  params!: GridDropdownParams;

  agInit(params: ICellRendererParams & { label: string; icon: string; items: DropdownItem[][] }): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
